import React, { useState,useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
  Container,
  InputAdornment,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApplicationType, entity_id, getGeolocation, location, locationGeo, Platform } from "../../Utils/Const";
import { baseapi } from "../../Environmentalurl";
import useIPAddress from "../../Utils/useIPAddress";
import api from "../../Utils/Api";

export default function VerifyMobile() {
  const steps = [
    "Mobile verification",
    "Profile Details",
    "Security Checkup",
    "Complete",
  ];

  const navigate = useNavigate();

 const ip = useIPAddress();
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  const handleGetOTP = async () => {
    if (mobile.length !== 10) {
      setError("Please enter a valid 10 digit mobile number");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const payload = {
        ReqType: "MT_Reg_GenerateOTP",
        Mobilenumber: mobile,
        Purpose: "Registration",
        EntityID: entity_id,
        TrxnAmount: "0",
        Platform: Platform,
        ApplicationType: ApplicationType,
        GeoLocation: locationGeo,
        MachineID: ip,
      };

      const response = await api.post(
        `${baseapi}/auth/generateotp`,
        payload
      );

      if (response.data.Response_Code === "1000") {
        const messageRefId = response.data.MessageRefID;
        navigate("/registration/lowkyc/verify-otp", {
          state: { mobile,messageRefId },
        });
      } else {
        setError(response.data.Message || "Failed to send OTP");
      }
    } catch (err) {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      <Box sx={{ bgcolor: "#f5f7f6", minHeight: "100vh", p: 6 }}>
        <Container maxWidth="md">
          <Box
            sx={{
              bgcolor: "white",
              borderRadius: 3,
              boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
              display: "flex",
              overflow: "hidden",
            }}
          >
            {/* Left */}
            <Box
              sx={{
                width: "40%",
                bgcolor: "#0aa34f",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 4,
              }}
            >
              <Box
                component="img"
                src="/Assets/image.png"
                sx={{ width: "100%", maxWidth: 260 }}
              />
            </Box>

            {/* Right */}
            <Box sx={{ width: "60%", p: 5 }}>
              <Stepper activeStep={0} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Typography variant="h5" fontWeight="bold" mt={4}>
                Verify Your Mobile Number
              </Typography>

              <Typography color="text.secondary" mt={1}>
                Please enter your mobile number to receive OTP
              </Typography>

              <Box sx={{ display: "flex", mt: 4, gap: 2 }}>
                <TextField value="+91" sx={{ width: 80 }} disabled />

                <TextField
                  fullWidth
                  placeholder="Enter Your Mobile Number"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                  inputProps={{ maxLength: 10 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              {error && (
                <Typography color="error" mt={2}>
                  {error}
                </Typography>
              )}

              <Button
                fullWidth
                sx={{
                  mt: 4,
                  bgcolor: "#0aa34f",
                  color: "white",
                  py: 1.5,
                  fontSize: 16,
                  "&:hover": { bgcolor: "#089445" },
                }}
                variant="contained"
                onClick={handleGetOTP}
                disabled={loading}
              >
                {loading ? "Sending OTP..." : "Get OTP"}
              </Button>

              <Typography textAlign="center" mt={2} color="text.secondary">
                Didn’t receive OTP? Resend after 30s
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      <Footer />
    </>
  );
}
